import styled from "@emotion/styled";
import { TableRow } from "@mui/material";

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  borderTop: "5px solid #FAFAFA",
}));
export const StickyClass = (index, mainStyle) => {
  return {
    position: { xs: "static", md: "sticky" },
    insetInlineStart: index === 0 ? 0 : 50, // Maps to 'left' in LTR and 'right' in RTL
    zIndex: "10",
    background: "white",
    ...mainStyle,
  };
};
export const TableCellStyle = (index, columns,isDetails) => {
  return {
    color: "#1A1A1A",
    fontWeight: "400",
    position: "relative",
    textTransform: "capitalize",
    cursor:isDetails && index === 0 && "pointer",
    wordBreak: "break-word",
    whiteSpace: "normal",
  };
};
export const TableContainerStyle = {
  maxWidth: "100%",
  boxShadow: "none",
  borderRadius: "8px 8px 0px 0px",
  overflowX: "auto",
};
